import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgListNumber = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4 16a2 2 0 1 1 4 0c0 .481-.214 1.214-.95 1.877C6.314 18.539 4.31 20 4.31 20h3.69M6 10V4L4.152 5.488M11.334 6H20m-8.666 6H20m-8.666 5.999H20"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgListNumber);
export default ForwardRef;
